/**
 * Layout Style registry — how the page is spatially organized. Capability
 * requirements come from Phase 2 knowledge: a Timeline layout only exists
 * for documents that support timelines, Collage/Grid need imagery.
 */

export const LAYOUT_STYLES = [
  { id: 'hero-top', name: 'Hero Top' },
  { id: 'hero-left', name: 'Hero Left' },
  { id: 'hero-right', name: 'Hero Right' },
  { id: 'centered', name: 'Centered' },
  { id: 'split', name: 'Split' },
  { id: 'grid', name: 'Grid', requiresCapabilities: ['supportsImages'] },
  { id: 'magazine', name: 'Magazine' },
  { id: 'timeline', name: 'Timeline', requiresCapabilities: ['supportsTimeline'] },
  { id: 'collage', name: 'Collage', requiresCapabilities: ['supportsImages'] },
  { id: 'diagonal', name: 'Diagonal' },
  { id: 'editorial', name: 'Editorial' },
  { id: 'minimal', name: 'Minimal' },
  { id: 'asymmetric', name: 'Asymmetric' },
];
